import { render, staticRenderFns } from "./Guchebao.vue?vue&type=template&id=3b2577a6&scoped=true&"
import script from "./Guchebao.vue?vue&type=script&lang=js&"
export * from "./Guchebao.vue?vue&type=script&lang=js&"
import style0 from "./Guchebao.vue?vue&type=style&index=0&id=3b2577a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2577a6",
  null
  
)

export default component.exports